module.exports = __webpack_public_path__ + "img/partners21_9.df95da15.jpg";